
import { Options, Vue } from 'vue-class-component'
import SearchResult from '@/components/Frontend/SearchResult/index.vue'

@Options({
  components: {
    SearchResult
  }
})
export default class SearchResultView extends Vue {}
